import { ref } from 'vue'
import { _firestoreCuenta, petición } from '@/../../cliente_comun/fuentes'
import { notificación } from '@/../../cliente_comun/utilidades'

export class ServicioDeGuardado {
	#recursoBase;
	#verificadorDeDatos;

	/**
	 * 
	 * @param {string} recursoBase - Ruta de recurso HTTP base.
	 * @param {Function} verificadorDeDatos - Función de verificación de datos ejecutada antes de enviar la petición al servidor. 
	 */
	constructor(recursoBase, verificadorDeDatos) {
		this.#recursoBase = recursoBase
		this.#verificadorDeDatos = verificadorDeDatos
		this.guardando = ref(false)
	}

	/**
	 * 
	 * @param {Object} datos - Datos.
	 * @param {string} mensaje - Mensaje de guardado exitoso.
	 * @returns 
	 */
	async crear(datos, mensaje) {
		this.#verificadorDeDatos(datos)
		const P = petición.post(this.#recursoBase, datos)
		await this.#guardar(P, mensaje)
	}

	/**
	 * 
	 * @param {string} identificador - Identificador de recurso.
	 * @param {Object} datos - Datos.
	 * @param {string} mensaje - Mensaje de guardado exitoso.
	 * @returns 
	 */
	async editar(identificador, datos, mensaje) {
		this.#verificadorDeDatos(datos)
		const recurso = `${this.#recursoBase}/${identificador}`
		const P = petición.put(recurso, datos)
		await this.#guardar(P, mensaje)
	}

	async #guardar(promesa, mensaje) {
		this.guardando.value = true
		mensaje = mensaje || 'Guardado.'

		try {
			await promesa
			notificación.correcto(mensaje)
			this.guardando.value = false
		} catch (e) {
			console.error('[9868363]', e)
			this.guardando.value = false
			throw null
		}
	}

}
